export const emailFormatRegex =
  /^(?!.*\.\.)(?=.{1,64}$)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const isPasswordValid = (password: string) =>
  password.length >= 8 &&
  containsUppercase(password) &&
  containsLowercase(password) &&
  containsNumber(password) &&
  containsSpecialChar(password) &&
  !containsInvalidChars(password);

export const containsUppercase = (value: string) => /[A-Z]/.test(value);

export const containsLowercase = (value: string) => /[a-z]/.test(value);

export const containsNumber = (value: string) => /[0-9]/.test(value);

export const containsSpecialChar = (value: string) =>
  /[@$!%*?&.,-]/.test(value);

export const containsInvalidChars = (value: string) =>
  /[^A-Za-z\d@$!%*?&.,-]/.test(value);

export const escapeStringForRegex = (str: string) => {
  return str.replace(/[-[\]{}()*+!<=:?./\\^$|#\s,]/g, '\\$&');
};

export const phoneFormatRegex =
  /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;

export const urlFormatRegex =
  /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?(\?[\w_=&-]+)?(#[\w_-]+)?$/;
